/**
 * Home News teaser pill — prefers specific labels from the edition payload (industry, etc.).
 */

const TOPIC_ALIASES = {
  artificial_intelligence: 'AI',
  ai: 'AI',
  advanced_manufacturing: 'Manufacturing',
  cyber_security: 'Cybersecurity',
  cybersecurity: 'Cybersecurity',
};

const MAX_PILL_LEN = 40;

function parseIndustryFromLinkTarget(linkTarget) {
  if (typeof linkTarget !== 'string') return '';
  const m = /^industry:(.+)$/.exec(linkTarget.trim());
  return m ? m[1].trim() : '';
}

/**
 * @param {string} raw
 * @returns {string}
 */
export function formatTopicLabelForPill(raw) {
  const s = String(raw).trim();
  if (!s) return '';
  const normalizedKey = s.toLowerCase().replace(/\s+/g, '_');
  if (TOPIC_ALIASES[normalizedKey]) return TOPIC_ALIASES[normalizedKey];
  if (s.includes('_')) {
    return s
      .split('_')
      .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() : ''))
      .join(' ');
  }
  if (s.length > MAX_PILL_LEN) return `${s.slice(0, MAX_PILL_LEN - 1)}…`;
  return s;
}

/**
 * @param {Record<string, unknown>} item — teaser row from /api/insights/v2/news/teaser
 * @returns {string}
 */
export function getNewsHeadlineTag(item) {
  if (!item || typeof item !== 'object') return 'Cross-sector';

  const topic = typeof item.topic === 'string' && item.topic.trim();
  if (topic) return formatTopicLabelForPill(topic);

  const industry = typeof item.industry === 'string' && item.industry.trim();
  if (industry) return formatTopicLabelForPill(industry);

  const technology = typeof item.technology === 'string' && item.technology.trim();
  if (technology) return formatTopicLabelForPill(technology);

  const fromLink = parseIndustryFromLinkTarget(item.linkTarget);
  if (fromLink) return formatTopicLabelForPill(fromLink);

  if (item.kind === 'industry') return 'Industry';
  return 'Cross-sector';
}
